var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "mb-3" }, [
        _c(
          "label",
          [
            _vm._t(
              "generalNameLabel",
              function() {
                return [
                  _vm._v("\n        " + _vm._s(_vm.$t("name")) + "\n      ")
                ]
              },
              { group: _vm.group }
            )
          ],
          2
        ),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.extractedGroup.name,
                expression: "extractedGroup.name"
              }
            ],
            staticClass: "form-control",
            domProps: { value: _vm.extractedGroup.name },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.extractedGroup, "name", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "mb-3 col-12 col-lg-6" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("group.model.createdOn")))]),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              staticClass: "form-control",
              attrs: { disabled: true },
              domProps: {
                value: _vm.formatDateTime(_vm.extractedGroup.createdOn)
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-3 col-12 col-lg-6" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("group.model.createdBy")))]),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              staticClass: "form-control",
              attrs: { disabled: true },
              domProps: {
                value: _vm.formatUserBaseName(
                  _vm.usersById.get(_vm.extractedGroup.createdBy)
                )
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.hidePinned
        ? _c("div", { staticClass: "mb-3" }, [
            _c("div", { staticClass: "form-check" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extractedGroup.isPinned,
                    expression: "extractedGroup.isPinned"
                  }
                ],
                staticClass: "form-check-input",
                attrs: { type: "checkbox", id: "isPinned" },
                domProps: {
                  checked: Array.isArray(_vm.extractedGroup.isPinned)
                    ? _vm._i(_vm.extractedGroup.isPinned, null) > -1
                    : _vm.extractedGroup.isPinned
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.extractedGroup.isPinned,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.extractedGroup,
                            "isPinned",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.extractedGroup,
                            "isPinned",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.extractedGroup, "isPinned", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form-check-label", attrs: { for: "isPinned" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("general.isPinned")) +
                      "\n      "
                  )
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("generalAfter", null, { group: _vm.group })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }